import React, { useState, useEffect } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';

const navItems = [
  { to: '/password-generator', label: 'Password' },
  { to: '/base64-converter', label: 'Base64' },
  { to: '/guid-generator', label: 'UUID' },
  { to: '/string-utilities', label: 'Text' },
  { to: '/json-formatter', label: 'JSON' },
  { to: '/jwt-decoder', label: 'JWT' },
];

const SiteLayout = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
  };

  return (
    <div className="site-shell">
      <div className="site-shell__backdrop" aria-hidden="true" />
      <header className="site-header">
        <div className="site-header__inner app-container">
          <Link to="/" className="site-brand">
            <span className="site-brand__mark">fp</span>
            <span>
              <strong>fpinto.dev</strong>
              <small>tools</small>
            </span>
          </Link>

          <nav className="site-nav" aria-label="Main navigation">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => `site-nav__link ${isActive ? 'is-active' : ''}`.trim()}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
          >
            {theme === 'light' ? '🌙' : '☀️'}
          </button>
        </div>
      </header>

      <main className="app-container site-main">
        <Outlet />
      </main>

      <footer className="site-footer app-container">
        <span>fpinto.dev</span>
        <span>Local · Browser only</span>
      </footer>
    </div>
  );
};

export default SiteLayout;
